import { useMutation, useQuery } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';
import { CompetitionConverter } from '@/converters/competition';
import { CompetitionService } from '../instances/competition';

// Hook para listar competições
export const useCompetition = () => {
  const query = useQuery(
    ['GET_COMPETITION'],
    async () => {
      const [err, data] = await CompetitionService.getCompetitions();
      if (err) {
        throw err;
      }
      return CompetitionConverter.toDomainFromGetResponse(data);
    },
    {
      refetchOnWindowFocus: false,
    },
  );

  const forceRefetch = useCallback(() => {
    query.remove();
    query.refetch();
  }, [query]);

  const returnQuery = useMemo(() => ({ ...query, forceRefetch }), [forceRefetch, query]);
  return returnQuery;
};

// Hook para criar uma nova competição
export const usePostCompetitionMutation = () => {
  return useMutation({
    mutationKey: ['POST_COMPETITION'],
    mutationFn: async (data: any) => {
      const [err, response] = await CompetitionService.postCompetition(data);
      if (err) {
        throw err;
      }
      return CompetitionConverter.toDomainFromPostResponse(response);
    },
  });
};

// Hook para atualizar uma competição por ID
export const usePutCompetitionMutation = () => {
  return useMutation({
    mutationKey: ['PUT_COMPETITION'],
    mutationFn: async ({ id, data }: { id: string; data: any }) => {
      const [err, response] = await CompetitionService.putCompetition(id, data);
      if (err) {
        throw err;
      }
      return CompetitionConverter.toDomainFromPutResponse(response);
    },
  });
};

// Hook para deletar uma competição por ID
export const useDeleteCompetitionMutation = () => {
  return useMutation({
    mutationKey: ['DELETE_COMPETITION'],
    mutationFn: async (id: string) => {
      const [err] = await CompetitionService.deleteCompetition(id);
      if (err) {
        throw err;
      }
      return;
    },
  });
};
